
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/discover/[pageSlug]",
      function () {
        return require("private-next-pages/[locale]/discover/[pageSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/discover/[pageSlug]"])
      });
    }
  